import SlotsHeatmapPage from '@/components/pages/calendar/slots-heatmap/slots-heatmap-page';

function SlotsPage() {
  return (
    <div className="h-full w-full">
      <SlotsHeatmapPage />
    </div>
  );
}

export default SlotsPage;
